import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
  import router from "@/router";
  import store from "@/store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Docusign',
  setup(__props, { expose: __expose }) {
  __expose();

  const params = new URLSearchParams(window.location.hash.slice(1));
  const isTokenReady = ref(false);
  const accessToken = params.get("access_token");

  const onBack = () => {
    const eoiId = sessionStorage.getItem("eoiId");

    sessionStorage.removeItem("eoiId");
    router.replace(`/eoi/${eoiId}`);
  };

  onMounted(() => {
    const accessToken = params.get("access_token");
    const expiresIn = Number(params.get("expires_in"));

    store
      .dispatch("docusign/getUserData", { accessToken, expiresIn })
      .then((res) => {
        store.commit("docusign/setUserData", {
          ...res.data,
          isLogged: true,
        });
      });

    isTokenReady.value = true;
  });

const __returned__ = { params, isTokenReady, accessToken, onBack, ref, onMounted, get router() { return router }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})